import React from "react";
import { Section, StatusTag } from "./primitives";
import { lifecycle as L } from "../mock/inferraData";

export default function Lifecycle() {
  return (
    <Section id="lifecycle" bg="var(--lav)" pt={150} pb={150}>
      <div className="lc-head" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: 70 }}>
        <h2 className="font-type reveal" style={{ margin: 0, maxWidth: 640, fontSize: "clamp(32px,4.4vw,58px)", fontWeight: 700, lineHeight: 1.03, letterSpacing: "-1.4px" }}>
          {L.heading}
        </h2>
        <p className="reveal d1" style={{ margin: 0, maxWidth: 420, fontSize: 17, lineHeight: 1.62, color: "var(--ink-soft)" }}>
          {L.body}
        </p>
      </div>

      <div className="lc-grid reveal" style={{ marginTop: 80, display: "grid", gridTemplateColumns: "repeat(6, minmax(0,1fr))", borderTop: "1px solid rgba(20,32,27,0.28)" }}>
        {L.stages.map((s, i) => (
          <div
            key={s.name}
            className="lc-col"
            style={{
              padding: "24px 20px 8px",
              paddingLeft: i === 0 ? 0 : 20,
              paddingRight: i === L.stages.length - 1 ? 0 : 20,
              borderRight: i === L.stages.length - 1 ? "none" : "1px solid var(--line)",
              display: "flex",
              flexDirection: "column",
              gap: 18,
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <span style={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: 12, color: "var(--amber-soft)" }}>{s.n}</span>
              <span style={{ fontSize: 19, fontWeight: 700 }} className="font-type">{s.name}</span>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 12, fontSize: 15 }}>
              {s.items.map((it) => (
                <div key={it.n} className="lc-item" style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                  <span style={{ fontWeight: 500 }}>{it.n}</span>
                  <StatusTag status={it.s} style={{ alignSelf: "flex-start" }} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @media (max-width: 980px) {
          .lc-head { flex-direction: column; align-items: flex-start; gap: 20px; }
          .lc-grid { grid-template-columns: repeat(3, minmax(0,1fr)); }
          .lc-col { border-right: none !important; border-bottom: 1px solid var(--line); padding-left: 0 !important; padding-right: 16px !important; }
        }
        @media (max-width: 560px) {
          .lc-grid { grid-template-columns: repeat(2, minmax(0,1fr)); }
        }
      `}</style>
    </Section>
  );
}
